import angular from 'angular';
import accountMenuDirective from './account-menu.directive';

let accountMenuModule = angular.module('catalog.category.accountMenu', [])
  .directive('accountMenu', accountMenuDirective);

export default accountMenuModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/header-core/account-menu/account-menu.js
 **/